import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { useAuth } from '../hooks/useAuth';
import AppLoader from './AppLoader';

interface AuthStore {
   isAuthenticated: boolean;
}

const PublicRoute = () => {
   const { isAuthenticated } = useAuthStore() as AuthStore;
   const { isLoading } = useAuth();

   if (isLoading) {
      return <AppLoader />;
   }

   return !isAuthenticated ? <Outlet /> : <Navigate to="/home" replace />;
};

export default PublicRoute;
